import superjson from "superjson";
import {
  defaultShouldDehydrateQuery,
  QueryClient,
} from "@tanstack/react-query";
import toast from "react-hot-toast";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
      },
      dehydrate: {
        serializeData: superjson.serialize,
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
      hydrate: {
        deserializeData: superjson.deserialize,
      },
      mutations: {
        onError(error) {
          if (
            error instanceof Error &&
            error.message.includes("Failed to fetch")
          ) {
            if (typeof window !== "undefined") {
              console.error(
                "Failed to fetch while sending mutation",
                error,
                error.cause,
              );
              toast.error("Looks like you aren't online right now...");
            }
          }
        },
      },
    },
  });
}
